import { api } from '../../api';
import { useMutation, UseMutationResult } from 'react-query';
import queryClient from '../../query-client';
import { AxiosError } from 'axios';

async function deactivate(entityId: string): Promise<void> {
    await api.post(`/entities/${entityId}/deactivation`);
}

export function useDeactivateEntity(): UseMutationResult<void, AxiosError, string, unknown> {
    return useMutation((entityId) => deactivate(entityId), {
        onSettled: (_, __, entityId) => {
            queryClient.invalidateQueries(['firm']);
            queryClient.invalidateQueries(['entities', entityId]);
            queryClient.invalidateQueries(['subscription']);
        },
    });
}
